'use client';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  query?: string | null;
  onSearch: React.ChangeEventHandler<HTMLInputElement>;
  [key: string]: unknown;
};

export default function RecipeSearch({ query, onSearch, ...other }: Props) {
  return (
    <TextField
      type="search"
      placeholder="Szukaj..."
      value={query ?? ''}
      onChange={onSearch}
      {...other}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ ml: 1, color: 'text.disabled' }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

